import { FC } from 'react';
import { logosData } from '../configs';
import { Logo } from './Logo';

export const KCTLogo: FC = () => {
  return (
    <div className="mr-2">
      <Logo 
        path={logosData.KCTLogo.path} 
        src={logosData.KCTLogo.src}
        name={logosData.KCTLogo.name}
        className="max-h-24 h-16 md:h-auto w-auto"  
      />
    </div>
  );
};